<template>
	<div class=" breadcrumb flex ali-cen" style="height: 50px;">
		<i class="iconfont ficon-position-o"></i>
		<div style="margin-right:10px ;">当前位置: </div>

		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
		  <el-breadcrumb-item  v-for="(item,index) in url" :key="index" :to="{ path: item.url }">{{item.name}}</el-breadcrumb-item>
		</el-breadcrumb>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				urls:[]
			}
		},
		methods:{

		},
		props:{
			url:{
				type:Array
			}
		},
		watch:{
			url:{
				handler(newValue){
				   console.log(newValue)
                   this.url = newValue
                   console.log(this.url);
				},
				immediate: true,
				deep:true
			}
		}
	}
</script>
<style lang="less">
	.breadcrumb{
		border-bottom: solid 1px #D5D5D5;
		font-size: 14px;
		color: #999999;
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb.vue